import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { fetchWheels, selectWheels } from './wheelsSlice';
import { selectCurrentItemOwner } from '../itemOwner/itemOwnersSlice';

import useTitle from '../../hooks/use-title.hook';

import {
  makeStyles,
  Button,
  Typography,
  Box
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import TopSection from '../common/topSection';
import Loading from '../common/loading';
import Alert from '../common/alert';
import WheelGrid from '../itemFamilies/ItemFamilyGrid'; // Same element, consider moving to common..?

const useStyles = makeStyles((theme) => ({
  newBtn: {
    marginLeft: 'auto'
  },
}));

const Wheels = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const itemOwnerId = useSelector(selectCurrentItemOwner);
  const { wheels, status, error } = useSelector(selectWheels);

  const wheelsWithRouterLinks = wheels.map(item => ({
    ...item,
    link: `/pih/owner/${itemOwnerId}/wheels/${item.code}`
  }));

  useTitle(t('wheel:wheels'));

  useEffect(() => {
    // Fetch all from server
    if(status === 'idle') {
      dispatch(fetchWheels({ownerId: itemOwnerId}));
    }
  }, [dispatch, itemOwnerId, status]);


  return (
    <>
      <TopSection>
        <Typography variant="h4" component="h1">{t('wheel:wheels')}</Typography>
        <Button
          component={Link}
          to={`/pih/owner/${itemOwnerId}/wheels/new`}
          variant="contained"
          color="primary"
          disableElevation
          startIcon={<AddIcon />}
          className={classes.newBtn}
        >
          {t('wheel:addNew')}
        </Button>
      </TopSection>

      <Box p={3.5}>
        {status === 'loading' ? <Loading /> : null}
        {status === 'failed' ? <Alert severity="error">{t(`errors:${error.message}`)}</Alert> : null}
        {status === 'succeeded' ? <WheelGrid items={wheelsWithRouterLinks} /> : null}
      </Box>
    </>
  )
};

export default Wheels;
